const settings = {
    selectors: {
        container: '[data-tooltip]',
    },

    dataAttributes: {
        content: 'data-tooltip',
    },

    classNames: {
        popup: 'tooltip__popup',
        visible: 'tooltip__popup--visible',

        positionAbove: 'tooltip__popup--above',
        positionBelow: 'tooltip__popup--below',

        positionLeft: 'tooltip__popup--left',
        positionCenter: 'tooltip__popup--center',
        positionRight: 'tooltip__popup--right',
    },

    sideEdgeMarginPixels: {
        mobile: 20,
        desktop: 60,
    },
};

export default class QuizTooltip {
    constructor(container, positioningContainer) {
        this.container = container;
        this.positioningContainer = positioningContainer;

        this.visible = false;

        const tooltipHtml = container.getAttribute(
            settings.dataAttributes.content,
        );
        if (!tooltipHtml) {
            return;
        }

        // Create popup
        this.popup = document.createElement('div');
        this.popup.className = settings.classNames.popup;
        this.popup.innerHTML = tooltipHtml;
        this.container.appendChild(this.popup);

        // Setup click event
        container.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (!this.visible) {
                this.show();
            }
        });
    }

    static init(positioningContainer) {
        if (!positioningContainer) {
            positioningContainer = document.body;
        }

        const elements = positioningContainer.querySelectorAll(
            settings.selectors.container,
        );
        for (const element of elements) {
            new QuizTooltip(element, positioningContainer);
        }
    }

    show() {
        if (this.visible) {
            return;
        }

        // Determine how to position the popup within its container - currently
        // this just checks if we're above or below & left or right of the center
        // of the containing element
        const buttonBounds = this.container.getBoundingClientRect();
        const containerBounds =
            this.positioningContainer.getBoundingClientRect();
        this.popup.className = settings.classNames.popup;

        // Vertical positioning
        const buttonCenterY = buttonBounds.top + buttonBounds.height / 2;
        const containerCenterY =
            containerBounds.top + containerBounds.height / 2;
        if (buttonCenterY >= containerCenterY) {
            // Button is below the center of the container
            this.popup.classList.add(settings.classNames.positionAbove);
        } else {
            // Button is above the center of the container
            this.popup.classList.add(settings.classNames.positionBelow);
        }

        // Horizontal positioning; we try to default to centered
        const buttonCenterX = buttonBounds.left + buttonBounds.width / 2;
        const containerCenterX =
            containerBounds.left + containerBounds.width / 2;

        // Check if the centered popup's left edge would be too close to the container edge
        let sideEdgeMarginPixels;
        if (window.matchMedia('screen and (min-width: 768px)').matches) {
            sideEdgeMarginPixels = settings.sideEdgeMarginPixels.desktop;
        } else {
            sideEdgeMarginPixels = settings.sideEdgeMarginPixels.mobile;
        }

        this.popup.style.visibility = 'hidden';
        this.popup.style.display = 'block';
        const halfPopupWidth = this.popup.clientWidth / 2;
        if (buttonCenterX >= containerCenterX) {
            // Button is right of center
            const testEdgeX = buttonCenterX + halfPopupWidth;
            if (
                testEdgeX >=
                containerBounds.right - sideEdgeMarginPixels
            ) {
                // Position to the left
                this.popup.classList.add(settings.classNames.positionLeft);
            } else {
                // Use centered positioning
                this.popup.classList.add(settings.classNames.positionCenter);
            }
        } else {
            // Button is left of center
            const testEdgeX = buttonCenterX - halfPopupWidth;
            if (
                testEdgeX <
                containerBounds.left + sideEdgeMarginPixels
            ) {
                // Position to the right
                this.popup.classList.add(settings.classNames.positionRight);
            } else {
                // Use centered positioning
                this.popup.classList.add(settings.classNames.positionCenter);
            }
        }

        this.popup.removeAttribute('style');

        // Show the popup
        this.visible = true;
        this.container.classList.add(settings.classNames.visible);

        // Add body click event to close the popup
        document.body.addEventListener(
            'click',
            (event) => {
                // Always close when we detect a click
                this.hide();

                // Stop propagation if the click occurred inside of our container;
                // otherwise it would trigger a click and re-open immediately
                const closestContainer = event.target.closest(
                    settings.selectors.container,
                );
                if (closestContainer) {
                    if (closestContainer == this.container) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            },
            {
                capture: true,
                once: true,
            },
        );
    }

    hide() {
        if (!this.visible) {
            return;
        }

        this.visible = false;
        this.container.classList.remove(settings.classNames.visible);
    }
}
